// extracted by mini-css-extract-plugin
export var bottomCallouts = "bottomCallouts-module--bottomCallouts--Q11E3";
export var revealContainer = "bottomCallouts-module--revealContainer--KIgP1";
export var callout = "bottomCallouts-module--callout--Tfm49";
export var scaleImg = "bottomCallouts-module--scaleImg--H3nbH";
export var imageWrap = "bottomCallouts-module--imageWrap--uWio5";
export var textHeading = "bottomCallouts-module--textHeading--Pk0va";
export var textSubtitle = "bottomCallouts-module--textSubtitle--PuRBq";
export var textButton = "bottomCallouts-module--textButton--FTvbs";
export var textLine = "bottomCallouts-module--textLine--S-Vd3";
export var imgTransformer = "bottomCallouts-module--imgTransformer--RVtxy";
export var contentWrap = "bottomCallouts-module--contentWrap--mBMXe";
export var slideUp = "bottomCallouts-module--slideUp--rz07-";
export var slideUpLarge = "bottomCallouts-module--slideUpLarge--97GGA";